import { render, staticRenderFns } from "./ChapterSelect.vue?vue&type=template&id=225b552d&scoped=true&"
import script from "./ChapterSelect.vue?vue&type=script&lang=js&"
export * from "./ChapterSelect.vue?vue&type=script&lang=js&"
import style0 from "./ChapterSelect.vue?vue&type=style&index=0&id=225b552d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225b552d",
  null
  
)

export default component.exports